export const ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST = "ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST";
export const ACCOUNTS_FILTERS_SEARCH_ROLES_RESULT = "ACCOUNTS_FILTERS_SEARCH_ROLES_RESULT";